import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import SearchInput from "../../components/common/SearchInput";
import Paginate from "../../components/common/pagination";

class NonVerifiedStudents extends Component {
  constructor(props) {
    super(props);

    this.state = {
      students: [],
      requestsPerPage: 10,
      skipRequests: 0,
      currentPage: 1,
      queryStr: "",
    };
  }

  componentDidMount = () => {
    this.getStudents();
  };

  getStudents = () => {
    const skip = this.state.skipRequests;
    const queryStr = this.state.queryStr;

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/students`, {
        withCredentials: true,
        params: {
          verified: false,
          skip,
          queryStr,
        },
      })
      .then((response) => {
        this.setState({ students: response.data.students });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  updateQueryStr = (newQuery) => {
    this.setState(
      {
        queryStr: newQuery,
      },
      () => {
        this.getStudents();
      }
    );
  };

  render() {
    const { currentPage, students } = this.state;
    const paginate = (pageNumber) =>
      this.setState(
        {
          currentPage: pageNumber,
          skipRequests: (pageNumber - 1) * 10,
        },
        () => this.getStudents()
      );
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Les Demandes Non Vérifiées"
            subtitle="Dashboard"
            className="text-sm-left"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <Col md={{ span: 4, offset: 6 }}>
                  <SearchInput updateQueryStr={this.updateQueryStr} />
                </Col>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <table className="table mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        #
                      </th>
                      <th scope="col" className="border-0">
                        Nom et prénom
                      </th>
                      <th scope="col" className="border-0">
                        ville
                      </th>

                      <th scope="col" className="border-0">
                        Telephone
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.map((student, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <Link
                            to={`/students/${student._id}`}
                            style={{ textDecoration: "none" }}
                          >
                            {student.firstName + " " + student.lastName}
                          </Link>
                        </td>
                        <td>{student.city}</td>
                        <td>{student.phone}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </CardBody>
              <CardFooter>
                <Col>
                  <Paginate
                    paginate={paginate}
                    currentPage={currentPage}
                    totalRequestInPage={students.length}
                  />
                </Col>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default NonVerifiedStudents;
